<div class="supplementary-equipment">
  <div class="form-box" [formGroup]="formGroup">
    <sc-flex vertical stretchContent>
      <h5>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.available.title"></sc-dictionary-label>
      </h5>
      @if (availableEquipment.length === 0) {
        <div class="form-checkbox">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.noEquipmentAvailable"></sc-dictionary-label>
        </div>
      }
      <ng-container formGroupName="available">
        @for (se of availableEquipment; track se; let i = $index) {
          <div class="form-checkbox">
            <sc-flex [formGroupName]="'' + i">
              <sc-checkbox-field [label]="se.name" formControlName="selected"></sc-checkbox-field>
              @if (se.availableIdentifiers?.length > 0) {
                <sc-content-spacer></sc-content-spacer>
                <mat-form-field class="checkbox-value" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-common.equipment.entity.equipment.identifier"></sc-dictionary-label></mat-label>
                    <mat-select formControlName="identifier" required="true" [value]="se.selectedIdentifier">
                      @for (identity of se.availableIdentifiers; track identity) {
                        <mat-option [value]="identity">{{identity}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </sc-flex>
            </div>
          }
        </ng-container>
        <h5>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.assigned.title"></sc-dictionary-label>
        </h5>
        @if (truck.equipment.length === 0) {
          <div class="form-checkbox">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.noEquipmentAssigned"></sc-dictionary-label>
          </div>
        }
        <ng-container formGroupName="handouted">
          @for (se of truck.equipment; track se; let i = $index) {
            <div class="form-checkbox">
              <sc-flex [formGroupName]="'' + i">
                <sc-checkbox-field [label]="se.name" formControlName="selected"></sc-checkbox-field>
                @if (se.selectedIdentifier != null) {
                  <sc-content-spacer></sc-content-spacer>
                  <sc-string-field [disabled]="true"
                    [textContent]="se.selectedIdentifier"
                  labelDictionaryKey="tmc-common.equipment.entity.equipment.identifier" ></sc-string-field>
                }
              </sc-flex>
            </div>
          }
        </ng-container>
      </sc-flex>
    </div>
  </div>
